/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Subscription_AccessInputs */

const en_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have access to the subscription management interface.`)
};

const fr_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas accès à l'interface de gestion des abonnements.`)
};

const de_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben keinen Zugriff auf die Benutzeroberfläche zur Abonnementverwaltung.`)
};

const it_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai accesso all'interfaccia di gestione degli abbonamenti.`)
};

const ru_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет доступа к интерфейсу управления подписками.`)
};

const es_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes acceso a la interfaz de gestión de suscripciones.`)
};

const zh_cn2_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您没有订阅管理界面的访问权限。`)
};

const ja_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション管理インターフェースにアクセスできません。`)
};

const hi_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको सदस्यता प्रबंधन इंटरफेस तक पहुंच प्राप्त नहीं है।`)
};

const pt_pt2_no_subscription_access = /** @type {(inputs: No_Subscription_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem acesso à interface de gerenciamento de assinaturas.`)
};

/**
* | output |
* | --- |
* | "You do not have access to the subscription management interface." |
*
* @param {No_Subscription_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_subscription_access = /** @type {((inputs?: No_Subscription_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Subscription_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_subscription_access(inputs)
	if (locale === "de") return de_no_subscription_access(inputs)
	if (locale === "it") return it_no_subscription_access(inputs)
	if (locale === "ru") return ru_no_subscription_access(inputs)
	if (locale === "es") return es_no_subscription_access(inputs)
	if (locale === "zh-CN") return zh_cn2_no_subscription_access(inputs)
	if (locale === "ja") return ja_no_subscription_access(inputs)
	if (locale === "hi") return hi_no_subscription_access(inputs)
	if (locale === "pt-PT") return pt_pt2_no_subscription_access(inputs)
	return en_no_subscription_access(inputs)
});